import { type Node } from '@xyflow/react'

export const SIZES = {
  NODE_WIDTH: 120,
  NODE_HEIGHT: 120,
  VERTICAL_SPACING_LEVEL_NODE: 10,
  NODE_LEVEL_HEIGHT: 40,
  INITIAL_LEVEL_NODE_VERTICAL_SPACING: 200,
  TREE_WIDTH_SPACING: 180,
  TREE_HEIGHT_SPACING: 200,
  EDGE_STROKE_WIDTH: 2,
  EDGE_RELATIVE_POSITION_TOP: 10,
}

type CustomNodeData = {
  label: string
  name: string
  type: string
  description: string
  id: number
  node_uuid: string
  childrenCount: number
  checked: boolean
  multiselectDisabled: boolean
}

export type CustomNode = Node<
  CustomNodeData & {
    expanded: boolean
    expandable?: boolean
    hasLevelChildren?: boolean
  }
>

export type CustomLevelNode = Node<CustomNodeData>

export interface SerializedTreeNode {
  id: number
  node_uuid: string
  type: string
  ancestor_id: number | null
  name: string
  description: string | null
  children: SerializedTreeNode[]
}
